<template>
    <div>
        <b-card>
            <b-row class="mb-2">
                <b-col :xl="12">
                    <b-card-text class="mb-1 text-left">
                        <b-link @click="toPrevMonth" v-if="hasPrevMonth">
                            <i class="fas fa-angle-left"></i>
                        </b-link>
                        {{ month }}
                        <b-link @click="toNextMonth" v-if="hasNextMonth">
                            <i class="fas fa-angle-right"></i>
                        </b-link>
                        <b-link class="float-right" @click="toLatestMonth" v-if="hasNextMonth">
                            <i class="fas fa-angle-double-right"></i>
                        </b-link>
                    </b-card-text>
                    <div class="text-center mt-3 mb-3" v-if="status == 'loading'">
                        <!-- <i class="fas fa-spinner fa-spin fa-2x"></i> -->
                    </div>
                    <template v-else-if="validData">
                        <h2 class="text-right text-nowrap text-primary">
                            {{ $_getDollar(thisMonth.cost) }}
                        </h2>
                        <div>
                            <b-card-text class="text-right mb-0" v-if="thisMonthEstimated.cost">
                                <small>
                                    ~ {{ thisMonth.date }}
                                </small>
                            </b-card-text>
                            <b-card-text class="text-right mb-0" v-if="prevMonth.cost && !thisMonthEstimated.cost">
                                <small>
                                    {{ Math.round(Math.abs((prevMonth.cost - thisMonth.cost) / prevMonth.cost) * 1000) / 10 }}%
                                    <span v-if="prevMonth.cost < thisMonth.cost">
                                        ▲
                                    </span>
                                    <span v-if="prevMonth.cost > thisMonth.cost">
                                        ▼
                                    </span>
                                    {{ $t('org.billing.Compared to previous month')}}
                                </small>
                            </b-card-text>
                        </div>
                        <hr>
                    </template>
                    <template v-else>
                        <h2 class="text-right">
                            {{ $t('v4.Not Available') }}
                        </h2>
                        <!-- <b-alert
                            variant="warning"
                            class="text-center p-2"
                            show
                        >
                            <div class="alert-body">
                                {{ $t('org.message.There are no usage details') }}
                            </div>
                        </b-alert> -->
                    </template>
                </b-col>
                <b-col
                    v-if="validData"
                    :xl="12"
                    class="mt-2"
                >
                    <div v-if="thisMonthEstimated.cost">
                        <h6>
                            {{ $t('org.billing.Estimated Cost') }}
                        </h6>
                        <h2 class="text-right text-nowrap text-primary">
                            {{ $_getDollar(thisMonthEstimated.cost) }}
                        </h2>
                        <b-card-text class="mb-0 text-right" v-if="prevMonth.cost">
                            <small class="text-nowrap">
                                {{ Math.round(Math.abs(estimated.increasedRate)) }}%
                                <span v-if="prevMonth.cost < thisMonthEstimated.cost">▲</span>
                                <span v-if="prevMonth.cost > thisMonthEstimated.cost">▼</span>
                            </small>
                            <br>
                            <small>
                                {{ $t('org.billing.Compared to previous month')}}
                            </small>
                        </b-card-text>
                    </div>
                    <b-card-text v-if="prevMonth.cost && !thisMonthEstimated.cost">
                        {{ $t('org.billing.Previous Month') }} <span class="float-right"> {{$_getDollar(prevMonth.cost).replace(' ','')}}</span>
                        <div class="clearfix"></div>
                    </b-card-text>
                </b-col>
            </b-row>
            <hr v-if="thisMonthEstimated.cost">
            <slot name="download"></slot>
            <hr v-if="thisMonthEstimated.cost && status !== 'loading'">
            <!-- 월별비용 bars -->
            <div v-if="status == '200' || status == 'loading'">
                <template
                    v-for="(year, yearIdx) in years.slice(0, 12)"
                >
                    <h4
                        class="mb-1"
                        :class="yearIdx > 0 ? 'mt-1' : undefined" :key="'title' + yearIdx"
                    >
                        {{ year }}
                    </h4>
                    <div
                        v-for="(month, monthIdx) in months.filter(item => item.month.substring(0,4) == year)"
                        :key="'box' + yearIdx + monthIdx"
                        style="background-color:rgba(115, 103, 240, 0.2)"
                        class="mb-1"
                    >
                        <div
                            @click="changeMonth(month.month)"
                            class="px-1 text-nowrap float-left text-white bg-primary mr-1"
                            :style="{
                                opacity: month.month !== months[months.length - 1].month ? 0.7 : 1,
                                'width': Math.min(Math.max((100 * month.cost / maxMonthCost), 0), 100) + '%',
                                'height': month.month === months[months.length - 1].month ? '15px' : '16px',
                                'font-weight': month.month === months[months.length - 1].month ? 'bold' : '',
                                'font-size': month.month === months[months.length - 1].month ? '11px' : '11px',
                                color: month.month === months[months.length - 1].month ? '' : ''
                            }"
                            style="border-radius:2px;cursor:pointer"
                        >
                            <span
                                v-if="Math.min(Math.max((100 * month.cost / maxMonthCost), 0), 100) > 60"
                                class="float-right"
                                :style="{
                                    'font-weight': month.month == months[months.length - 1].month ? 'bold' : ''
                                }"
                            >
                                {{ $_getDollar(month.cost).replace(' ','') }}
                            </span>
                            {{ $t(`v4.${__getMonthShortString(month.month.substring(5, 7))}`) }}
                        </div>
                        <span
                            v-if="Math.min(Math.max((100 * month.cost / maxMonthCost), 0), 100) <= 60"
                            class="float-left"
                            style="height:15px;font-size:11px;border-radius: 2px;"
                            :style="{
                                'font-weight': month.month == months[months.length - 1].month ? 'bold' : ''
                            }"
                        >
                            {{ $_getDollar(month.cost).replace(' ','') }}
                        </span>
                        <div class="clearfix"></div>
                    </div>
                </template>
            </div>
        </b-card>
    </div>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { computed, toRefs } from '@vue/composition-api'
export default {
    props: {
        months: {
            type: Array,
            default: function () {
                return []
            }
        },
        month: {
            type: String,
            default: ''
        },
        allMonths: {
            type: Array,
            default: function () {
                return []
            }
        },
        current: {
            type: Object,
            default: function () {
                return {}
            }
        },
        estimated: {
            type: Object,
            default: function () {
                return {}
            }
        },
        status: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            default: ''
        }
    },
    setup (props, context) {
        const { __getMonthShortString } = useCommonData()
        const {
            months,
            current,
            estimated,
            month,
            allMonths,
            status
        } = toRefs(props)

        /** computed */
        const years = computed(() => {
            return months.value.map(item => item.month.substring(0, 4)).filter((obj, pos, arr) => {
                return arr.indexOf(obj) === pos
            })
        })
        const thisMonth = computed(() => ({
            cost: current.value?.cost,
            month: current.value?.date?.substring(0, 7) ?? '',
            date: current.value?.date?.substring(2, 7) ?? ''
        }))
        const prevMonth = computed(() => (months.value[months.value.length - 2] || {
            cost: 0,
            month: ''
        }))
        const validData = computed(() => thisMonth.value.month && thisMonth.value.date && (status.value === '200' || status.value === '206'))
        const maxMonthCost = computed(() => months.value.length ? Math.max.apply(null, months.value.map(item => item.cost)) : 0)
        const monthIndex = computed(() => allMonths.value.indexOf(month.value))
        const hasNextMonth = computed(() => monthIndex.value > 0)
        const hasPrevMonth = computed(() => monthIndex.value < allMonths.value.length - 1)

        /** method */
        const toPrevMonth = () => context.emit('change-month', allMonths.value[monthIndex.value + 1])
        const toNextMonth = () => context.emit('change-month', allMonths.value[monthIndex.value - 1])
        const toLatestMonth = () => context.emit('change-month', allMonths.value[0])
        const changeMonth = (month) => context.emit('change-month', month)

        return {
            __getMonthShortString,
            validData,
            years,
            thisMonth,
            thisMonthEstimated: estimated,
            prevMonth,
            maxMonthCost,
            hasNextMonth,
            hasPrevMonth,
            toPrevMonth,
            toNextMonth,
            toLatestMonth,
            changeMonth
        }
    }
}
</script>

<style>

</style>
